function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 14.2A1.8 1.8 0 005.8 16h1.8a8.4 8.4 0 018.4 8.4v1.8a1.8 1.8 0 001.8 1.8h8.4a1.8 1.8 0 001.8-1.8v-1.8C28 13.133 18.867 4 7.6 4H5.8A1.8 1.8 0 004 5.8v8.4z"
});

var SvgSpectrum = function SvgSpectrum(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTQsMTQuMiBDNCwxNS4xOTM2IDQuODA2NCwxNiA1LjgsMTYgTDcuNiwxNiBDMTIuMjM5MiwxNiAxNiwxOS43NjA4IDE2LDI0LjQgTDE2LDI2LjIgQzE2LDI3LjE5MzYgMTYuODA2NCwyOCAxNy44LDI4IEwyNi4yLDI4IEMyNy4xOTM2LDI4IDI4LDI3LjE5MzYgMjgsMjYuMiBMMjgsMjQuNCBDMjgsMTMuMTMzMiAxOC44NjY4LDQgNy42LDQgTDUuOCw0IEM0LjgwNjQsNCA0LDQuODA2NCA0LDUuOCBMNCwxNC4yIFoiPjwvcGF0aD4KPC9zdmc+Cg==";
export { SvgSpectrum as ReactComponent };